app.controller('stateOfHealthDiagnosisListController', ['$scope', '$state', '$mdDialog', '$translate',
    'edm.applicationModel', 'patientModel', 'diagnosisModel', 'userModel',
    function ($scope, $state, $mdDialog, $translate, applicationModel, patientModel, diagnosisModel, userModel) {

        var listeners = {};

        function setData() {
            $scope.diagnoses = null;
            $scope.numberOfPages = null;

            $scope.criteria = new DiagnosisDataGridCriteria();
            $scope.criteria.idPatient = $state.params.patientId;
            $scope.currentUserId = userModel.currentUser.id;

            $scope.columns = [
                {
                    displayName: 'T.DATA.DATE',
                    cellTemplate: 'edm/application/view/app/patient/grid-template/data-row-dates.html'
                },
                {
                    field: 'icd10.description',
                    displayName: 'T.MODULE.PATIENT.RECOGNITION'
                },
                {
                    field: 'additionalNotes',
                    displayName: 'T.MODULE.PATIENT.NOTES'
                },
                {
                    field: 'chronicAffliction | yesNo',
                    displayName: 'T.MODULE.PATIENT.CHRONIC'
                },
                {
                    cellTemplate: 'edm/application/view/app/patient/grid-template/data-diagnosis-row-actions.html'
                }
            ];

            $scope.buttons = [
                {
                    icon: 'content:add',
                    action: 'addDiagnosis'
                },
                {
                    label: $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ALL'),
                    action: 'getDataPage'
                }
            ];

            $scope.showOptions = {
                all: false
            }
        }


        function setPermissions() {
        }

        function setListeners() {
            listeners.onDiagnosisDataPageLoad = function(dataPage) {
                $scope.diagnoses = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            }
        }

        function setActions() {
            $scope.criteriaChanged = function () {
                $scope.getDiagnosisDataPage().then(listeners.onDiagnosisDataPageLoad);
            };

            $scope.addDiagnosis = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-diagnosis.html',
                    controller: 'popupDiagnosisCreateController'
                }).then(function (data) {
                    $scope.getDiagnosisDataPage();
                }, function () {
                    //cancel
                });
            };

            $scope.previewDiagnosis = function(diagnosis, previewOnly) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-diagnosis.html',
                    controller: 'popupDiagnosisUpdateController',
                    resolve: {
                        diagnosisToUpdate: function() {
                            return diagnosis;
                        },
                        preview: function() {
                            return true;
                        }
                    }
                }).then(function (data) {
                    $scope.getDiagnosisDataPage();
                }, function () {
                    //cancel
                });
            };

            $scope.deleteDiagnosis = function(diagnosis) {
                if(diagnosis.visit) {
                    applicationModel.confirm('T.MODULE.PATIENT.DIAGNOSIS_CONNECTED_WITH_VISIT_CARD').then(function () {
                        $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT, { patientId: diagnosis.patient.id, visitId: diagnosis.visit.id });
                    });
                } else {

                    var label = diagnosis.icd10.description;
                    if(diagnosis.notes) {
                        label += ' (' + diagnosis.notes + ')';
                    }
                    var configPopup = {
                        templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                        controller: 'popupDeleteWithReasonController',
                        controllerAs: 'deleteConfirmCtrl',
                        skipHide: true,
                        locals: {
                            labels: label,
                            item: angular.copy(diagnosis),
                            userModel: userModel,
                            $mdDialog: $mdDialog,
                            message: 'T.MODULE.PATIENT.ILLNESS_DELETE_CONFIRMATION'
                        }
                    };

                    $mdDialog.show(configPopup).then(function(data) {
                        diagnosisModel.update(data).then(function() {
                            $scope.getDiagnosisDataPage();
                        });
                    });

                }
            };

            $scope.changeButtonLabel = function() {
                if($scope.showOptions.all) {
                    $scope.buttons[1].label = $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ACTIVE_ONLY');
                } else {
                    $scope.buttons[1].label = $translate.instant('T.MODULE.PERSONAL_DATA.SHOW_ALL');
                }
            };

            $scope.getDiagnosisDataPage = function(changeButton) {
                if(changeButton) {
                    $scope.showOptions.all = !$scope.showOptions.all;
                    $scope.changeButtonLabel();
                }
                if(!$scope.showOptions.all) {
                    if($scope.criteria.allowDeleted) {
                        delete $scope.criteria.allowDeleted;
                    }
                } else {
                    if(!$scope.criteria.allowDeleted) {
                        $scope.criteria.allowDeleted = true;
                    }
                }
                diagnosisModel.getDataPage($scope.criteria).then(listeners.onDiagnosisDataPageLoad);
            };

            $scope.getDataPage = function() {
                $scope.getDiagnosisDataPage(true);
            };

            $scope.userHasAccessToDeleteEntity = function(entity) {
                return entity.author.id === $scope.currentUserId || (entity.author.userType === 'MEDICAL_OFFICE' && userModel.currentUser.userType === Enum.USER_TYPE.DOCTOR);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            applicationModel.fillViewportMode = true;
            $scope.getDiagnosisDataPage();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);